import dayjs from "dayjs";
import { debounce } from "lodash";
import { useCallback, useEffect, useState } from "react";
import { CSVLink } from "react-csv";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import Select, { StylesConfig } from "react-select";
import { constantsPermission } from "../../../Config/Constants";
import TableLoading from "../../../core/common/loadingComponent/TableLoading";
import ManageColumn from "../../../core/common/ManageCoulmnsButton/ManageColumn";
import NoRecordFound from "../../../core/common/noRecord/NoRecordFound";
import Pagination from "../../../core/common/pagination/Pagination";
import Ribbon from "../../../core/common/ribbon/ribbon";
import TableHeading from "../../../core/common/tableHeading/TableHeading";
import TextField from "../../../core/common/textFields/TextField";
import { usePermission } from "../../../core/hooks/PermissionHook";
import { useTableSelection } from "../../../core/hooks/useTableSelection";
import { setProjectId } from "../../../Features/commonSlice";
import { useGetAllProjectDetailsQuery, useGetListingFiltersLookUpsQuery } from "../../../services/EndPointsApis";
import { svgIcons } from "../../../style/fonts/SvgIcons";
import ContactWizard from "./ContactWizard/ContactWizard";
import FilterModalProjects from "./FilterModalProjects";
import { initialColumnProjects } from "./ManageColumn/ProjectModuleColumns";
import PdmAssignModalProject from "./PDMAssignModal";


const Projects = () => {
  const dispatch = useDispatch();
  const activityToggle = useSelector(
    (state: any) => state?.activityTogglePopup
  );
  const activityToggleTwo = useSelector(
    (state: any) => state?.activityTogglePopupTwo
  );
  const formattedDate = dayjs().format("YYYY-MM-DD_HH-mm-ss");


  const [showfilterModal, setShowfilterModal] = useState(false);
  const [showPdmModal, setShowPdmModal] = useState(false);
  const [currentToggleState, setCurrentToggleState] = useState(false);
  const [showAddUpdateUserModal, setShowAddUpdateUserModal] = useState(false)
  const [viewOnly, setViewOnly] = useState(false)
  const [selectedfilter, setSelectedFilter] = useState({ value: 0, label: '' })
  const [isRowClicked, setIsRowClicked] = useState(false)
  const [pageNumber, setPageNumber] = useState(() => {
    return parseInt(sessionStorage.getItem("projectsPage") || "1", 10);
  });
  const [pageSize, setPageSize] = useState(15);
  const [searchStr, setSearchStr] = useState(''); // debounce search
  const [sortBy, setSortBy] = useState("createDT");
  const [sortOrder, setSortOrder] = useState("desc");
  const [sortedColumn, setSortedColumn] = useState("createDT");
  const [immediateSearchStr, setImmediateSearchStr] = useState('')

  //Permission Hook 
  const { view, edit, delete: canDelete, create, assign } = usePermission(constantsPermission?.moduleId?.project);

  const { data: allProjects, isFetching: allProjectIsloading, refetch } = useGetAllProjectDetailsQuery({
    pageNumber: pageNumber,
    pageSize: pageSize,
    searchStr: searchStr || '',
    sortBy: sortBy,
    sortOrder: sortOrder,
    FilterString: selectedfilter?.value
  });

  const { data, isLoading, refetch: refetchFilter } = useGetListingFiltersLookUpsQuery({ FilterType: 'Project' });

  const { data: allProjectsCSV, refetch: refetchProjectCsv, isLoading: allProjectIsloadingcsv } = useGetAllProjectDetailsQuery({
    pageNumber: pageNumber,
    pageSize: 1000,
    searchStr: searchStr || '',
    sortBy: sortBy,
    sortOrder: sortOrder,
    FilterString: selectedfilter?.value
  });


  const handlePageSizeChange = (selectedOption: any) => {
    setPageSize(selectedOption.value);
    setPageNumber(1); // Reset page number to 1
  };
  // pagination
  const handlePageClick = (e: any) => {
    setPageNumber(e.selected + 1);
    sessionStorage.setItem("projectsPage", String(e.selected + 1));
  };
  //per page record
  const handlePageRecords = (e: any) => {
    setPageNumber(1); // Reset the page to 1
  };
  const handleSort = (property: string) => {
    setSortBy(property);
    if (sortedColumn === property) {
      setSortOrder(prevSortOrder => (prevSortOrder === "asc" ? "desc" : "asc"));
    } else {
      setSortedColumn(property);
      setSortOrder("asc");
    }
    // Perform additional sorting logic...
  };

  //Search
  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setImmediateSearchStr(value);

    if (value.trim() === '') {
      setSearchStr('');
    }
  };

  const handleSearchClick = () => {
    setSearchStr(immediateSearchStr);
  };

  const delayedSearch = useCallback(
    debounce((searchValue) => {
      setSearchStr(searchValue);
    }, 800),
    []
  );
  useEffect(() => {
    if (searchStr === "" ||
      sortOrder === "" ||
      sortBy === "") {
      refetch();
    }
  }, [sortOrder, sortBy]);

  useEffect(() => {
    refetch();
  }, [setSelectedFilter]);

  const {
    isTableHeadChecked,
    selectedIndividualCheckboxId,
    selectedItemData: projectData,
    handleTableHeadChange,
    handleCheckItem,
    handleRowClick,
    handleRowDoubleClick
  } = useTableSelection(allProjects?.result?.data || [], 'id');

  const handlefiltermodel = () => {
    setShowfilterModal(true);
    const dropdownToggle = document.getElementById(idValue);
    if (dropdownToggle) {
      dropdownToggle.click();
    }
  }

  const isAnyCheckboxChecked = selectedIndividualCheckboxId.length > 0;
  const isMoreThanOneChecked = selectedIndividualCheckboxId.length > 1;
  const [checkUncheck, setCheckUncheck] = useState()

  const handleClosefilterModal = () => {
    setShowfilterModal(false)
  };

  const handleDoubleClick = (items: any) => {
    if (!view) {
      return
    }
    dispatch(setProjectId(items?.id));
    localStorage.setItem('projectId', (items.id));
    navigate(`/projects/editProject/details/${items?.id}`);
    handleRowDoubleClick(items);
    setViewOnly(true);
    setShowAddUpdateUserModal(true);
  };

  const handleRowClicked = (data: any) => {
    handleRowClick(data);
    setIsRowClicked(true);
    if (data?.active === true) {
      setCurrentToggleState(true)
    } else {
      setCurrentToggleState(false)
    }
  }

  const customStyles: StylesConfig = {
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? "rgba(177, 31, 40, 1)" : "#fff",
      color: state.isFocused ? "#fff" : "#000",
      "&:hover": {
        backgroundColor: "rgba(177, 31, 40, 1)",
      },
    }),
  };

  const [selectedDate1, setSelectedDate1] = useState<Date | null>(new Date());

  const handleDateChange1 = (date: Date | null) => {
    setSelectedDate1(date);
  };
  // const [selectedIndividualCheckboxId, setSelectedRowId] = useState<any[]>([]);
  const navigate = useNavigate();
  const handleViewDetails = () => {
    if (selectedIndividualCheckboxId) {
      // navigate(`/projectUserDetails/${selectedIndividualCheckboxId}`);
      navigate(`/projects/view-project/details/${selectedIndividualCheckboxId}`);
    } else {
      alert("Please select a row first.");
    }
  };
  const handlefilterManage = () => {
  };

  // const handleRowDoubleClick = (record: { id: string }) => {
  //   const id = record.id;
  //   navigate(`/projectUserDetails/${id}`);
  // };
  const handleEditProject = () => {
    if (selectedIndividualCheckboxId.length >= 1) {
      dispatch(setProjectId(selectedIndividualCheckboxId[0]));
      localStorage.setItem('projectId', (selectedIndividualCheckboxId[0]));
      navigate(`/projects/editProject/details/${selectedIndividualCheckboxId}`);
      // navigate(`/editProject/details/${selectedIndividualCheckboxId}`);
      // navigate(`/editProject/${selectedIndividualCheckboxId}`);
    }
  }
  const idValue = 'dropdownMenuClickableInsise1';

  // const handlefiltermodel = () => {
  //   setShowfilterModal(true);
  //   const dropdownToggle = document.getElementById(idValue);
  //   if (dropdownToggle) {
  //     dropdownToggle.click();
  //   }
  // }

  const [visibleColumns, setVisibleColumns] = useState(() => {
    const savedColumns = localStorage.getItem('columnSettingsProject');
    return savedColumns
      ? JSON.parse(savedColumns)
      : initialColumnProjects.reduce((acc, column) => ({ ...acc, [column.id]: column.checked }), {});
  });
  const handleColumnToggle = (updatedColumns: any) => {
    setVisibleColumns(updatedColumns);
    localStorage.setItem('columnSettingsProject', JSON.stringify(updatedColumns));
  }

  const handleClose = () => {
    setShowfilterModal(false)
  };
  const handleClosePdmModal = () => {
    setShowPdmModal(false)
  };

  const handleAssignPdm = () => {
    // setShowPdmModal(true)
    navigate(`/projects/editProject/assignments/${selectedIndividualCheckboxId}`)
  }

  const handleStoreProjectId = (id: any) => {
    dispatch(setProjectId(id));
    localStorage.setItem('projectId', (id));
    navigate(`/projects/editProject/details/${id}`)
  }

  const items = [
    {
      label: "Edit",
      tooltipLabel: "Edit",
      icon: svgIcons.updateIcon,
      onClick: handleEditProject,
      handleViewDetails,
      disableButton: !isAnyCheckboxChecked || isMoreThanOneChecked || !edit,
      disableIcon: svgIcons.updateIcon,
    },
    // {
    //   label: "View Details",
    //   tooltipLabel: "View details", icon: svgIcons.eyeIcon, onClick: handleViewDetails,
    //   disableButton: !isAnyCheckboxChecked || isMoreThanOneChecked || !view,
    //   disableIcon: svgIcons.eyeIcon,

    // },
    {
      label: "Assign PDM",
      icon: svgIcons.usersIcon,
      onClick: handleAssignPdm,
      tooltipLabel: "Assign PDM",
      disableButton: !isAnyCheckboxChecked || isMoreThanOneChecked || !assign,
      disableIcon: svgIcons.usersIcon,
    },
    // {
    //   label: "Contacts",
    //   icon: svgIcons.contactsIcon,
    //   // onClick: handleViewDetails,
    //   // tooltipLabel: "View details",
    //   // disableButton: !isAnyCheckboxChecked || isMoreThanOneChecked,
    //   // disableIcon: svgIcons.disableEyeIcon
    // },
    // {
    //   label: "Notes",
    //   icon: svgIcons.noteIcon,
    //   // onClick: handleViewDetails,
    //   // tooltipLabel: "View details",
    //   // disableButton: !isAnyCheckboxChecked || isMoreThanOneChecked,
    //   // disableIcon: svgIcons.disableEyeIcon
    // },
    // {
    //   label: "Client Vists",
    //   icon: svgIcons.clientVisits,
    //   // onClick: handleViewDetails,
    //   // tooltipLabel: "View details",
    //   // disableButton: !isAnyCheckboxChecked || isMoreThanOneChecked,
    //   // disableIcon: svgIcons.disableEyeIcon
    // },
    // {
    //   label: "Teams",
    //   icon: svgIcons.usersIcon,
    //   // onClick: handleViewDetails,
    //   // tooltipLabel: "View details",
    //   // disableButton: !isAnyCheckboxChecked || isMoreThanOneChecked,
    //   // disableIcon: svgIcons.disableEyeIcon
    // },
    // { label: "Priority:", icon: svgIcons.PirorityIcon, DropdownButton: <CustomSelect options={dropdownItems} /> },
    // { label: "Save", icon: svgIcons.SaveIcon },
    // { tooltipLabel: "Refresh", icon: <i className="ti ti-refresh"></i>, },
    // { tooltipLabel: "Export", icon: <i className="ti ti-upload"></i> },
  ];

  const [activityTogglePopup, setActivityTogglePopup] = useState(false);

  const handleAddNewProject = () => {
    setActivityTogglePopup(true)
  }

  const handlecloseSidebar = () => {
    setActivityTogglePopup(false)
  }

  //csv data 
  const headers = initialColumnProjects.map(item => ({
    label: item.name,
    key: item.key,
  }));

  const CsvData = allProjectsCSV?.result?.data?.map((record: Record<string, any>) => {
    const csvRecord: Record<string, any> = {};

    headers.forEach((header) => {
      const key = header.key;
      csvRecord[key] = record[key]?.value ?? record[key] ?? "";
    });

    // headers.forEach((header) => {
    //   const key = header.key;
    //   let value = record[key]?.value ?? record[key] ?? "";

    //   // Handle ZIP code formatting
    //   if (key.toLowerCase().includes("zip")) {
    //     value = String(value).padStart(5, '0')
    //   }

    //   csvRecord[key] = value;
    // });


    return csvRecord;
  }) || [];

  return (
    <>
      <ContactWizard activityTogglePopup={activityTogglePopup} closeSidebar={handlecloseSidebar} refetch={refetch} />
      <FilterModalProjects show={showfilterModal} handleClose={handleClose} />
      <PdmAssignModalProject show={showPdmModal} handleClose={handleClosePdmModal} selectedIndividualCheckboxId={selectedIndividualCheckboxId} />

      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          <div className="row">
            <div className="col-md-12">
              <Ribbon
                items={items}
                buttonText="+ Add New Project"
                buttonClass="add-popup ribbon-btn "
                onClickbtn={handleAddNewProject}
                disabled={!create}
              />
              {/* /Page Header */}
              <div className="card main-card">
                <div className="card-body">
                  {/* Search */}
                  <div className="search-section">
                    <div className="row">
                      <div className="col-md-4 col-sm-8 mb-2">
                        <h4 className="page-title color-red">Projects</h4>
                      </div>
                      <div className="col-md-8 mb-2">
                        <div className="d-flex flex-column flex-md-row justify-content-end gap-2 ">
                          <CSVLink data={CsvData} headers={headers} filename={`Project_List ${formattedDate}.csv`} className="btn btn-light-red d-flex justify-content-center gap-1 align-items-center">
                            <i className="fa fa-file-export" />
                            Export To CSV
                          </CSVLink>
                          <ManageColumn columns={initialColumnProjects} visibleColumns={visibleColumns} onColumnToggle={handleColumnToggle} />
                          {/* <FilterComponent handlefiltermodel={handlefiltermodel} idValue={idValue} /> */}
                          <Select
                            className="select project-select"
                            placeholder='Select Filter'
                            styles={customStyles}
                            options={data?.result?.map((option: any) => ({
                              label: option?.value,
                              value: option?.id
                            })) || null}

                            value={selectedfilter ?
                              {
                                label: selectedfilter?.label || 'Select Filter',
                                value: selectedfilter?.value
                              }
                              :
                              null
                            }

                            onChange={(selectedOption: any) => setSelectedFilter(selectedOption)}
                          />
                          <div className="d-flex align-items-center gap-2">
                            <div className="icon-form">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Search Project"
                                value={immediateSearchStr}
                                onChange={handleSearchChange}
                                onKeyDown={(e) => {
                                  if (e.key === "Enter") {
                                    e.preventDefault();
                                    handleSearchClick();
                                  }
                                }}
                              />
                            </div>
                            <div>
                              <button className="btn btn-primary" onClick={handleSearchClick}>
                                <span className="form-icon">
                                  <i className="ti ti-search" />
                                </span>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Projects List */}
                  <div className="col-md-12">
                    <div className="table-responsive custom-table mt-2 overflow-auto">
                      <table className="table datanew dataTable no-footer table-hover">
                        <thead>
                          <tr>
                            <th>
                              <input
                                type="checkbox"
                                className='form-check-input cursor-pointer'
                                checked={isTableHeadChecked}
                                onChange={handleTableHeadChange}
                              />
                            </th>
                            {initialColumnProjects.map((column) => (
                              visibleColumns[column.id] &&

                              <TableHeading
                                label={column.name}
                                sortedColumn={column.name}
                                columnId={column.name}
                                sortOrder='desc'
                                handleSort={() => handleSort(column.key)}
                              />

                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {!allProjectIsloading &&
                            <>
                              {allProjects?.result?.data?.length > 0 ? (
                                <>
                                  {allProjects?.result?.data?.map((data: any, index: any) => {
                                    return (
                                      <>
                                        <tr key={data?.id} onClick={() => handleRowClicked(data)} onDoubleClick={() => handleDoubleClick(data)}
                                          className={selectedIndividualCheckboxId.includes(data?.id) ? 'selected-row' : ''}>
                                          <td>
                                            <TextField
                                              type="checkbox"
                                              fieldClass='form-check-input cursor-pointer'
                                              checked={isTableHeadChecked || selectedIndividualCheckboxId.includes(data.id)}
                                              onChange={(e) => handleCheckItem(e, data)}
                                            />
                                          </td>
                                          {initialColumnProjects.map((column) => (
                                            visibleColumns[column.id] && (
                                              <td key={column.id}>
                                                {
                                                  column.key === 'projectStatus' ? (
                                                    //   data[column.key] === "Active" ? (
                                                    //     <span className="badge badge-pill badge-status bg-soft-success text-success"> {data.projectStatus} </span>
                                                    //   ) : (
                                                    //     <span className="badge badge-pill badge-status bg-soft-gray text-muted">None</span>
                                                    //   )
                                                    // )
                                                    <span className=""> {data.projectStatus} </span>)

                                                    // : column.key === 'recordNumber' ? (
                                                    //   <Link to={`/leadsProspect/editLead/${data?.leadProspectId}`}>
                                                    //     {data?.recordNumber || 'N/A'}
                                                    //   </Link>
                                                    // ) 
                                                    : column.key === 'recordNumber' ? (
                                                      <div className="cursor-pointer" onClick={() => handleStoreProjectId(data?.id)}>
                                                        <span className=""> {data?.recordNumber || ''}</span>

                                                      </div>
                                                    ) : column.key === 'contactName' ? (
                                                      <Link to={`/contacts/EditContacts/${data?.contactId}`}>
                                                        <span className=""> {data?.contactName || ''}</span>

                                                      </Link>
                                                    ) : column.key === 'accountName' ? (
                                                      <Link to={`/accounts/EditAccounts/${data?.accountId}`}>
                                                        <span className=" "> {data?.accountName || ''}</span>

                                                      </Link>
                                                    ) : (
                                                      data[column.key] !== undefined && data[column.key] !== null ? (
                                                        typeof data[column.key] === 'object' && data[column.key] !== null ? (
                                                          data[column.key].value !== undefined ? (
                                                            data[column.key].value
                                                          ) : (
                                                            ''
                                                          )
                                                        ) : (
                                                          data[column.key]
                                                        )
                                                      ) : (
                                                        ''
                                                      )
                                                    )}
                                              </td>
                                            )
                                          ))}
                                        </tr>
                                      </>
                                    )
                                  })}
                                </>
                              ) :
                                (
                                  <tr>
                                    <td colSpan={20}>
                                      <NoRecordFound />
                                    </td>
                                  </tr>
                                )}
                            </>}
                          {allProjectIsloading &&
                            <TableLoading />
                          }
                          {/* {allProjectIsloadingcsv &&
                            <TableLoading />
                          } */}
                        </tbody>
                      </table>
                    </div>
                    <Pagination
                      onChange={handlePageSizeChange}
                      pageSize={pageSize}
                      onPageChange={handlePageClick}
                      pageCount={allProjects?.result?.totalPages || 0}
                      forcePage={pageNumber - 1}
                    />
                  </div>
                  {/* <Table dataSource={data} columns={columns} onRowSelect={(keys: any[]) => setSelectedRowId(keys)} onDoubleClick={handleRowDoubleClick} paginations={true} /> */}
                  <div className="row align-items-center">
                    <div className="col-md-6">
                      <div className="TableData-length" />
                    </div>
                    <div className="col-md-6">
                      <div className="TableData-paginate" />
                    </div>
                  </div>
                  {/* /Projects List */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


    </>
  );
};

export default Projects;
